// extracted by mini-css-extract-plugin
export var externalLink = "_ej-0";
export var internalLinkLabel = "_ej-1";